export const initialState = {
  notifications: [],
};

const inAppNotifications = (state = initialState, action) => {
  switch (action.type) {
    case 'LIST_IN_APP_NOTIFICATIONS':
      return {
        ...state,
        notifications: action.data,
      };
    default:
      return state;
  }
};

export default inAppNotifications;
